import type { CourseworkGroup } from "@/lib/api/courseworkPolicy";

/**
 * What one group revision changed, against the revision before it, in the
 * words a teacher uses. The first revision names the members it began with.
 */
export function groupChange(entry: CourseworkGroup, previous: CourseworkGroup | undefined, learner: (enrollmentId: string) => string): string {
  const members = (ids: string[]) => ids.map(learner).join(", ") || "no members";
  if (!previous) return `created ${entry.name} with ${members(entry.enrollment_ids)}`;
  const changes: string[] = [];
  if (entry.name !== previous.name) changes.push(`renamed this group to ${entry.name}`);
  if (entry.state !== previous.state) changes.push(entry.state === "archived" ? "archived this group" : "restored this group");
  const added = entry.enrollment_ids.filter(id => !previous.enrollment_ids.includes(id));
  const removed = previous.enrollment_ids.filter(id => !entry.enrollment_ids.includes(id));
  if (added.length) changes.push(`added ${members(added)}`);
  if (removed.length) changes.push(`removed ${members(removed)}`);
  if (!changes.length) return `saved ${entry.name} unchanged`;
  return `${changes.join("; ")}${added.length || removed.length ? "" : "; members unchanged"}`;
}
